import qs from 'qs';


export const dotNotationParamsSerializer = (params: any): string => {
  const res = qs.stringify(params, { 
    allowDots: true, 
    arrayFormat: 'repeat' 
  });

  return res
};